import React from 'react';
import { MOIS_COURTS } from '../utils/constants';
import { fmtUnit, fmtLabel } from '../utils/helpers';

// unit : respecte le sélecteur d'unité de la section parente
const CumulChart = ({ labels, realise, budget, color1 = '#1565c0', color2 = '#9e9e9e', unit }) => {
  if (!labels?.length) return null;
  const cumR = [], cumB = [];
  let sr = 0, sb = 0;
  labels.forEach((_, i) => { sr += realise[i] || 0; cumR.push(sr); sb += budget[i] || 0; cumB.push(sb); });
  const maxVal = Math.max(...cumR, ...cumB, 1);
  const W = 520, H = 110, PL = 52, PR = 10, PT = 8, PB = 22;
  const n = labels.length;
  const xS = i => PL + (n > 1 ? (i / (n - 1)) * (W - PL - PR) : (W - PL - PR) / 2);
  const yS = v => PT + (1 - v / maxVal) * (H - PT - PB);
  const polyR = cumR.map((v, i) => `${xS(i)},${yS(v)}`).join(' ');
  const polyB = cumB.map((v, i) => `${xS(i)},${yS(v)}`).join(' ');
  return (
    <div style={{ marginTop: 10, borderTop: '1px dashed #f0ebe4', paddingTop: 8 }}>
      <div style={{ fontSize: '0.6rem', color: '#bbb', marginBottom: 4, display: 'flex', gap: 14 }}>
        <span><span style={{ display: 'inline-block', width: 14, height: 2, background: color1, verticalAlign: 'middle', marginRight: 4, borderRadius: 1 }} />Cumul Réalisé</span>
        <span><span style={{ display: 'inline-block', width: 14, height: 2, background: color2, verticalAlign: 'middle', marginRight: 4, borderRadius: 1, opacity: 0.6 }} />Cumul Budget</span>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ minWidth: n * 26, display: 'block' }}>
          {[0, 0.5, 1].map(f => (
            <line key={f} x1={PL} x2={W - PR} y1={yS(maxVal * f)} y2={yS(maxVal * f)} stroke="#f0ebe4" strokeWidth="1" />
          ))}
          <polygon
            points={[`${xS(0)},${yS(0)}`, ...cumR.map((v, i) => `${xS(i)},${yS(v)}`), `${xS(n - 1)},${yS(0)}`].join(' ')}
            fill={color1} opacity="0.07"
          />
          <polyline points={polyB} fill="none" stroke={color2} strokeWidth="1.5" strokeDasharray="5 3" opacity="0.6" />
          <polyline points={polyR} fill="none" stroke={color1} strokeWidth="2.5" />
          {cumR.map((v, i) => (
            <circle key={i} cx={xS(i)} cy={yS(v)} r="3" fill={color1}>
              <title>{fmtLabel(labels[i])} : {fmtUnit(v, unit)}</title>
            </circle>
          ))}
          {labels.map((lbl, i) => (
            <text key={i} x={xS(i)} y={H - 4} textAnchor="middle" fontSize="8" fill="#bbb">
              {MOIS_COURTS[parseInt(lbl.slice(5, 7), 10) - 1]}
            </text>
          ))}
          {[0.5, 1].map(f => (
            <text key={f} x={PL - 3} y={yS(maxVal * f) + 3} textAnchor="end" fontSize="8" fill="#bbb">{fmtUnit(maxVal * f, unit)}</text>
          ))}
        </svg>
      </div>
    </div>
  );
};

export default CumulChart;
